module.exports = __webpack_public_path__ + "static/media/Rita Cornwell Alcove units (5).36c57b56.JPG";